<template>
    <div class="sms-send-container">
        <div class="sms-send-header">
            <div class="sms-send-header__title">
                Lista invitați
            </div>
        </div>

        <div class="sms-send-table-wrap">
        <table-lite
            v-if="scopedProjectData"
            :has-checkbox="true"
            :is-slot-mode="true"
            :is-static-mode="true"
            :is-loading="loading"
            :columns="columns"
            :rows="scopedProjectData.participants"
            :messages="messages"
            :total="scopedProjectData.participants.length"
            :sortable="sortable"
            :pageOptions="pageOptions"
            :is-hide-paging="true"
            @return-checked-rows="updateCheckedRows"
        >
            <template v-slot:sms_sent_time="data">
                <div class="">
                    <div
                        class="tooltip tooltip-left cursor-default"
                        :data-tip="`Invitatie trimisa prin SMS la ${data.value.sms_sent_time}`"
                        v-if="data.value.sms_sent_time"
                    >
                        <font-awesome-icon
                            icon="fa-solid fa-envelope-circle-check"
                            class="text-primary text-2xl pl-1"
                        />
                    </div>

                    <div
                        class="tooltip tooltip-left cursor-default"
                        :data-tip="`Invitatia nu a fost trimisa`"
                        v-else
                    >
                        <font-awesome-icon
                            icon="fa-solid fa-envelope"
                            class="text-neutral text-2xl"
                        />
                    </div>
                </div>
            </template>
        </table-lite>
        </div>

        <div class="sms-send-actions">
            <div
                v-if="selectedForSMSSend.length == 0 && !isTermsCheckboxChecked"
                class="bg-base-200 py-2 rounded-lg mt-2 text-sm md:text-lg"
            >
                Alege cui vrei sa trimiti invitatia prin SMS
            </div>
            <div
                v-else-if="
                    selectedForSMSSend.length == 0 && isTermsCheckboxChecked
                "
                class="bg-accent py-2 rounded-lg mt-2 text-sm md:text-lg"
            >
                Trebuie sa alegi cel putin un invitat!
            </div>
            <div
                v-else-if="selectedForSMSSend.length > credit.sms_credits"
                class="bg-accent py-2 rounded-lg mt-2 text-sm md:text-lg"
            >
                Nu ai suficiente credite!
            </div>
            <div v-else class="bg-secondary text-white mt-2 text-sm md:text-lg rounded-lg py-2">
                Urmeaza sa trimiti invitatia catre
                {{ selectedForSMSSend.length }}
                <span v-if="selectedForSMSSend.length > 1">invitați!</span>
                <span v-else>invitat!</span>
            </div>

            <InvitationMessage
                class="sms-send-preview"
                v-if="scopedProjectData && scopedProjectData.invitation_message"
                :projectId="scopedProjectData.project_id"
                :projectName="scopedProjectData.project_name"
                :projectSlug="scopedProjectData.project_slug"
                :userMessage="scopedProjectData.invitation_message"
                :hideForm="true"
            />
            <div class="sms-send-footer">
                <div class="sms-send-terms">
                    <label class="sms-send-terms__label">
                        <input
                            type="checkbox"
                            v-model="isTermsCheckboxChecked"
                            class="checkbox checkbox-primary"
                        />
                        <span class="sms-send-terms__text"
                            >Am citit și sunt de acord cu
                            <RouterLink
                                to="/termsAndConditions"
                                class="underline italic"
                                >Termenii și condițiile generale</RouterLink
                            >

                            și sunt de acord să trimit invitația.</span
                        >
                    </label>
                </div>

                <button
                    v-if="SMSSendingInProgress"
                    class="btn btn-primary w-full md:w-auto md:btn-wide sms-send-submit"
                    :class="{
                        'btn-disabled':
                            !isTermsCheckboxChecked ||
                            !selectedForSMSSend.length ||
                            SMSSendingInProgress,
                    }"
                >
                    <span class="loading loading-spinner"></span>
                    Se trimite
                </button>

                <button
                    @click="sendSMSInvitation()"
                    v-else
                    class="btn btn-primary w-full md:w-auto md:btn-wide sms-send-submit"
                    :class="{
                        'btn-disabled':
                            !isTermsCheckboxChecked ||
                            !selectedForSMSSend.length ||
                            SMSSendingInProgress ||
                            selectedForSMSSend.length > credit.sms_credits,
                    }"
                >
                    <font-awesome-icon icon="fa-solid fa-paper-plane" />
                    Trimite Invitatia
                </button>
            </div>

            <!-- Display failed SMS -->
            <div v-if="failedSMS.length > 0" class="divide-y mt-10">
                <div class="divide-y"></div>
                <h3>A aparut o eroare la urmatoarele adrese:</h3>
                <ul>
                    <li v-for="(sms, index) in failedSMS" :key="index">
                        {{ sms }}
                    </li>
                </ul>
            </div>
        </div>

        <div v-if="loading">
            <div
                class="backdrop fixed w-full h-full bg-white z-50 top-0 right-0 left-0 bottom-0 opacity-90 flex justify-center"
            >
                <span class="loading loading-ring loading-lg"></span>
            </div>
        </div>
    </div>
</template>

<script>
import axios from 'axios';
import TableLite from 'vue3-table-lite';
import { useToast } from 'vue-toastification';
import InvitationMessage from './InvitationMessage.vue';
import { mapGetters } from 'vuex';

export default {
    props: {
        projectId: {
            required: true,
        },
        closeSendSMSModal: {
            type: Function,
            required: true,
        },
        isSendSMSModalOpen: {
            type: Boolean,
            required: true,
        },
        setSMSJobStatus: {
            type: Function,
            required: true,
        },
    },
    computed: {
        ...mapGetters([
            'user',
            'projects',
            'plan',
            'credit',
            'loading',
            'scopedProjectData',
        ]),
    },
    watch: {
        isSendSMSModalOpen(newValue) {
            if (newValue) {
                const projectId = this.$route.params.projectId; // Assuming projectId is a URL parameter
                const options = { mobile: true };
                this.$store.dispatch('fetchProjectUsers', {
                    projectId,
                    options,
                    participants: true,
                });
            }
        },
    },
    components: {
        TableLite,
        InvitationMessage,
    },
    data() {
        return {
            isTermsCheckboxChecked: false,
            selectedForSMSSend: [],
            failedSMS: [],
            SMSSendingInProgress: false,
            pageOptions: [{ value: 999, text: 999 }],
            columns: [
                {
                    label: 'Nume',
                    field: 'recipient_surname',
                    width: '10%',
                    sortable: true,
                },
                {
                    label: 'Prenume',
                    field: 'recipient_name',
                    width: '10%',
                    sortable: true,
                },
                {
                    label: 'Mobile',
                    field: 'recipient_mobile',
                    width: '15%',
                    sortable: false,
                    isKey: true,
                },
                {
                    label: 'Status Invitatie',
                    field: 'sms_sent_time',
                    width: '5%',
                    sortable: true,
                },
            ],
            sortable: {
                order: 'recipient_name',
                sort: 'desc',
            },
            messages: {
                pagingInfo:
                    'Se afiseaza {0} din {1} rezultate | Total {2} rezultate',
                pageSizeChangeLabel: 'Randuri afisate: ',
                gotoPageLabel: ' Mergi la pagina: ',
                noDataAvailable: 'Nu sunt disponibile informatii',
            },
        };
    },
    setup() {
        // Get toast interface
        const toast = useToast();

        // Make it available inside methods
        return { toast };
    },
    mounted() {},
    methods: {
        setLoading(state) {
            this.$store.commit('setLoading', state);
        },
        updateCheckedRows(rowsKey) {
            this.selectedForSMSSend = rowsKey;
        },
        async sendSMSInvitation() {
            try {
                const jwtToken = localStorage.getItem('userToken');
                this.SMSSendingInProgress = true;
                this.setSMSJobStatus(true);
                this.failedSMS = [];

                setTimeout(() => {
                    if (this.SMSSendingInProgress == true) {
                        // Close the modal
                        this.closeSendSMSModal();
                    }
                }, 1000);

                await axios
                    .post(
                        `/api/index.php?endpoint=sendSMSInvitation`,
                        {
                            phone_list: this.selectedForSMSSend,
                            project_id: this.projectId,
                        },
                        {
                            headers: {
                                'Content-Type': 'application/json',
                                Authorization: `Bearer ${jwtToken}`,
                            },
                        }
                    )
                    .then((response) => {
                        this.SMSSendingInProgress = false;
                        if (response.data.success) {
                            this.toast.success(
                                'Succes! Invitatia se trimite chiar acum.'
                            );
                            this.closeSendSMSModal();
                        } else {
                            this.toast.error('A aparut o eroare.');

                            // Add failed SMS to the failed SMS array
                            if (response.data.sms_responses) {
                                response.data.sms_responses.forEach(
                                    (smsResponse) => {
                                        if (!smsResponse.success) {
                                            this.failedSMS.push(
                                                smsResponse.sms
                                            );
                                        }
                                    }
                                );
                            }
                        }
                    })
                    .catch((error) => {
                        this.toast.error(
                            'Invitatia nu s-a trimis catre: ' + error
                        );
                    });
                this.setSMSJobStatus(false);

                const burnedCredits =
                    this.selectedForSMSSend.length - this.failedSMS.length;

                // Calculate the new value for s,s_credits
                const newSMSCredits =
                    this.$store.state.credit.sms_credits - burnedCredits;

                this.$store.commit('setSMSCredits', newSMSCredits);
            } catch (error) {
                console.error(
                    'A aparut o eroare:',
                    error.response ? error.response.data : error.message
                );
                this.toast.error('A aparut o eroare.');
            }
        },
    },
};
</script>

<style>
.sms-send-container {
    width: 100%;
    min-width: 0;
    overflow: hidden;
}
.sms-send-header {
    padding: 8px 0 0;
}
.sms-send-header__title {
    font-size: 28px;
    font-weight: 400;
    margin-bottom: 8px;
}
.sms-send-table-wrap {
    width: 100%;
    min-width: 0;
    overflow-x: auto;
    -webkit-overflow-scrolling: touch;
}
.sms-send-table-wrap .vtl {
    width: 100%;
    min-width: 0;
    overflow: visible;
}
.sms-send-table-wrap .vtl-card-body {
    overflow: visible;
}
.sms-send-table-wrap .vtl-table {
    min-width: 520px;
    width: 100%;
    font-size: 13px;
}
.sms-send-table-wrap .vtl-thead-th {
    white-space: nowrap;
    font-size: 12px;
    padding: 8px 10px;
}
.sms-send-table-wrap .vtl-tbody-td {
    padding: 8px 10px;
    font-size: 13px;
    word-break: break-all;
}
.sms-send-actions {
    padding: 0 4px;
}
.sms-send-preview {
    margin: 16px auto 0;
}
.sms-send-footer {
    display: flex;
    flex-direction: column;
    align-items: stretch;
    gap: 12px;
    margin-top: 16px;
}
.sms-send-terms {
    flex: 1;
}
.sms-send-terms__label {
    display: flex;
    align-items: flex-start;
    gap: 10px;
    cursor: pointer;
    text-align: left;
}
.sms-send-terms__text {
    font-size: 13px;
    line-height: 1.5;
}
.sms-send-submit {
    align-self: flex-end;
    flex-shrink: 0;
    margin-top: 4px;
}
@media (min-width: 768px) {
    .sms-send-header__title {
        font-size: 36px;
    }
    .sms-send-footer {
        flex-direction: row;
        align-items: center;
        justify-content: space-between;
    }
    .sms-send-submit {
        margin-top: 0;
    }
}
</style>
